import { defineComponent as _defineComponent } from 'vue'
import S3FileMangeService from "@/services/S3FileManageService";
import ResponseData from "@/types/ResponseData";
import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);

const openCalendarPDF = () => {
  isLoading.value = false;
  const data = {
    folderName: "smc_calendar",
    fileName: "SMC Calendar.pdf",
  };
  S3FileMangeService.getS3File(data)
    .then((response: ResponseData) => {
      var data = response.data;
      if (response.status == 200) {
        window.open(data.filePath)?.focus();
      }
      isLoading.value = false;
    })
    .catch((e: Error) => {
      // file not found
      alert("Target file does not exist!!!");
      console.log(e);
      isLoading.value = false;
    });
};

const __returned__ = { isLoading, openCalendarPDF }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})